import { SearchOptionLinksObject, SearchApi } from 'components/SA/SearchProvider/types'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { getPagePath } from 'selectors/page'
import { filterPopularSearches } from './helpers/transformPopularSearches'

type UsePopularSearchesParams = {
  searchService: SearchApi
  maxPopularSearches?: number
}

type GetPopularSearchesParams = {
  selectedCategory: string
}

const usePopularSearches = ({
  searchService,
  maxPopularSearches = 5,
}: UsePopularSearchesParams) => {
  const [popularSearches, setPopularSearches] = useState<ReadonlyArray<SearchOptionLinksObject>>([])
  const urlPath = useSelector(getPagePath)
  const urlPathParamsArray = urlPath.split('/').filter(Boolean)
  const firstPathParam = urlPathParamsArray[0] || ''
  const selectedCategory = firstPathParam === 'prints' ? urlPathParamsArray[1] : firstPathParam

  const getPopularSearches = async ({ selectedCategory }: GetPopularSearchesParams) => {
    const popularSearchesResponse = await searchService.fetchSearchProviderRecommendations({
      podId: 'trending-searches',
      section: 'Search Suggestions',
      numResults: 100,
    })

    if (popularSearchesResponse.success) {
      const filteredPopularSearches = filterPopularSearches({
        selectedCategory,
        popularSearches: popularSearchesResponse.payload.data.recommendations,
        maxPopularSearches,
      })
      setPopularSearches(filteredPopularSearches)
      return
    }

    setPopularSearches([])
  }

  useEffect(() => {
    getPopularSearches({ selectedCategory })
  }, [selectedCategory])

  return { popularSearches, getPopularSearches, setPopularSearches }
}

export default usePopularSearches
